import React, { createContext, useEffect, useState } from "react";
import { fetchDestinationPackages } from "../services/packageService";

export const PackagesContext = createContext();

const fallbackImages = {
  UAE: {
    image1:
    "https://images.pexels.com/photos/1467300/pexels-photo-1467300.jpeg?w=1500",
      // "https://plus.unsplash.com/premium_photo-1697729914552-368899dc4757?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8ZHViYWl8ZW58MHx8MHx8fDA%3D",
    image2: [
      "https://plus.unsplash.com/premium_photo-1661964303354-f0496d6d6e0b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8ZHViYWl8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8ZHViYWl8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/flagged/photo-1559717865-a99cac1c95d8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8ZHViYWl8ZW58MHx8MHx8fDA%3D",
      "https://plus.unsplash.com/premium_photo-1661943659036-aa040d92ee64?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8ZHViYWl8ZW58MHx8MHx8fDA%3D",
    ],
  },
  Thailand: {
    image1:
    "https://images.pexels.com/photos/208444/pexels-photo-208444.jpeg?w=1500",
      // "https://plus.unsplash.com/premium_photo-1661962958462-9e52fda9954d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dGhhaWxhbmR8ZW58MHx8MHx8fDA%3D",
    image2: [
      "https://images.unsplash.com/photo-1494948949099-1311f3e907a9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fHRoYWlsYW5kfGVufDB8fDB8fHww",
      "https://plus.unsplash.com/premium_photo-1661962432490-6188a6420a81?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fHRoYWlsYW5kfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dGhhaWxhbmR8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1563492065599-3520f775eeed?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8dGhhaWxhbmR8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1513568720563-6a5b8c6caab3?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHRoYWlsYW5kfGVufDB8fDB8fHww",
      "https://media.istockphoto.com/id/1022233370/photo/young-woman-traveler-with-backpack-traveling-into-beautiful-pagoda-in-wat-chalong-or-chalong.webp?a=1&b=1&s=612x612&w=0&k=20&c=fG9ikOTH3b3qVwUJJlpg8rVpQPM3YlfeeQgc3VmX7tE=",
    ],
  },
  "Sri Lanka": {
    image1:
    "https://images.pexels.com/photos/330260/pexels-photo-330260.jpeg?w=1500",
      // "https://images.unsplash.com/photo-1651264042769-ef84e30f4ac8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8c3JpJTIwbGFua2F8ZW58MHx8MHx8fDA%3D",
    image2: [
      "https://images.unsplash.com/photo-1519566335946-e6f65f0f4fdf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8c3JpJTIwbGFua2F8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1580910527739-556eb89f9d65?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c3JpJTIwbGFua2F8ZW58MHx8MHx8fDA%3D",
      "https://plus.unsplash.com/premium_photo-1681223447322-46794b8cdfd5?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8c3JpJTIwbGFua2F8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1624963145509-5b52cba74cee?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fHNyaSUyMGxhbmthfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1612862862126-865765df2ded?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHNyaSUyMGxhbmthfGVufDB8fDB8fHww",
      "https://media.istockphoto.com/id/181665005/photo/elephants-in-the-beautiful-landscape.webp?a=1&b=1&s=612x612&w=0&k=20&c=k5peYXLS-zasXhfxA4MQgvq4yPI8IkCzjolV0L2Bp6o=",
      "https://media.istockphoto.com/id/538041824/photo/cave-temple-in-dambulla-sri-lanka.webp?a=1&b=1&s=612x612&w=0&k=20&c=rJhQzF7FQ_mwhlL29HdDYotyvr6gQZ9HngfDbzIbTxM=",
      "https://media.istockphoto.com/id/1212935972/photo/container-port-and-container-ship-transportation-at-colombo.webp?a=1&b=1&s=612x612&w=0&k=20&c=ytd_2sX2q6OGlojx0O_EdwMl9BY-HVAb8MloCPKprbQ=",
      "https://media.istockphoto.com/id/1441928899/photo/mahout-riding-his-elephant-sigiriya-rock-on-the-background-sri-lanka.jpg?s=612x612&w=0&k=20&c=JC1fW_oI_9535lH8dZvQQZK5CPAZK269u_5XR3HZFIg=",
      "https://media.istockphoto.com/id/181665005/photo/elephants-in-the-beautiful-landscape.jpg?s=612x612&w=0&k=20&c=Qm80W1hx4FN-kF4d3lZ0_Ftwbf_G9_7CzxCNGHNfJpk=",
    ],
  },
  "Hong Kong": {
    image1:
    "https://images.pexels.com/photos/2861883/pexels-photo-2861883.jpeg?w=1500",
      // "https://images.unsplash.com/photo-1554208786-6776fa9e7df4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aG9uZyUyMGtvbmd8ZW58MHx8MHx8fDA%3D",
    image2: [
      "https://plus.unsplash.com/premium_photo-1661887262365-1d6a1cf3da22?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8aG9uZyUyMGtvbmd8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1620015092538-e33c665fc181?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGhvbmclMjBrb25nfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1518599807935-37015b9cefcb?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8aG9uZyUyMGtvbmd8ZW58MHx8MHx8fDA%3D",
      "https://media.istockphoto.com/id/695357146/photo/stock-market-exchange-on-a-skyscraper-in-hong-kong-background.webp?a=1&b=1&s=612x612&w=0&k=20&c=UizwHOA9BR2br2dSpbsHWm9B4GmhBJ4sUE8Lzi_KUPc=",
      "https://images.unsplash.com/photo-1577871598838-a543ee47cd79?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGhvbmclMjBrb25nfGVufDB8fDB8fHww",
    ],
  },
  Maldives: {
    image1:
    "https://images.pexels.com/photos/1483053/pexels-photo-1483053.jpeg?w=1500",
      // "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bWFsZGl2ZXN8ZW58MHx8MHx8fDA%3D",
    image2: [
      "https://plus.unsplash.com/premium_photo-1666286163385-abe05f0326c4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8bWFsZGl2ZXN8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1467377791767-c929b5dc9a23?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bWFsZGl2ZXN8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fG1hbGRpdmVzfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1576158831003-d41033ec31fd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8bWFsZGl2ZXN8ZW58MHx8MHx8fDA%3D",
      "https://plus.unsplash.com/premium_photo-1691675471605-e52d9151406d?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fG1hbGRpdmVzfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1503125210483-8b1d12bccdbe?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fG1hbGRpdmVzfGVufDB8fDB8fHww",
      "https://plus.unsplash.com/premium_photo-1680339680335-7e3b8572fc00?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fG1hbGRpdmVzfGVufDB8fDB8fHww",
      "https://media.istockphoto.com/id/1293037576/photo/a-hugging-couple-in-white-summer-clothing-stands-on-a-tropical-beach.webp?a=1&b=1&s=612x612&w=0&k=20&c=_RE4aTDLoPAt0iYLzbS8zfW_rQRFMMhxU2Le_bZWRWw=",
    ],
  },
  Singapore: {
    image1:
    "https://images.pexels.com/photos/777059/pexels-photo-777059.jpeg?w=1500",
      // "https://images.unsplash.com/photo-1600664356348-10686526af4f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fHNpbmdhcG9yZXxlbnwwfHwwfHx8MA%3D%3D",
    image2: [
      "https://plus.unsplash.com/premium_photo-1697729432930-3f11644e9184?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8c2luZ2Fwb3JlfGVufDB8fDB8fHww",
      "https://images.unsplash.com/flagged/photo-1562503542-2a1e6f03b16b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8c2luZ2Fwb3JlfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1496939376851-89342e90adcd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8c2luZ2Fwb3JlfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8c2luZ2Fwb3JlfGVufDB8fDB8fHww",
    ],
  },
  Indonesia: {
    image1:
    "https://images.pexels.com/photos/2474690/pexels-photo-2474690.jpeg?w=1500",
      // "https://plus.unsplash.com/premium_photo-1661878915254-f3163e91d870?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YmFsaXxlbnwwfHwwfHx8MA%3D%3D",
    image2: [
      "https://images.unsplash.com/photo-1604999333679-b86d54738315?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8YmFsaXxlbnwwfHwwfHx8MA%3D%3D",
      "https://media.istockphoto.com/id/2203631834/photo/scenic-morning-view-of-mount-batur-and-surrounding-landscape-in-bali-indonesia.webp?a=1&b=1&s=612x612&w=0&k=20&c=QBdqqlLrSF-bulLCE3VwJKDOGTj77mRex-rH4zB8-y0=",
      "https://images.unsplash.com/photo-1518548419970-58e3b4079ab2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8YmFsaXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1544644181-1484b3fdfc62?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTJ8fGJhbGl8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1558005530-a7958896ec60?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGJhbGl8ZW58MHx8MHx8fDA%3D",
      "https://media.istockphoto.com/id/1172847194/photo/traveler-standing-at-the-gates-of-pura-lempuyang-temple-aka-gates-of-heaven-bali-indonesia.webp?a=1&b=1&s=612x612&w=0&k=20&c=9U6KrZqiBSNbpw7pmaNZ73Oz9fxP4ZdiVVNQxx4k0jw=",
    ],
  },
  "Andaman & Nicobar": {
    image1: 
    "https://images.pexels.com/photos/30188165/pexels-photo-30188165.jpeg?w=1500",
    // "https://images.unsplash.com/photo-1638459483713-075bd8941006?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8QW5kYW1hbiUyMCUyNiUyME5pY29iYXJ8ZW58MHx8MHx8fDA%3D",
    image2: [
      "https://plus.unsplash.com/premium_photo-1745571156883-e4821acca5d4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fEFuZGFtYW4lMjAlMjYlMjBOaWNvYmFyfGVufDB8fDB8fHww", 
      "https://plus.unsplash.com/premium_photo-1730035378960-0aab7e339ff2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fEFuZGFtYW4lMjAlMjYlMjBOaWNvYmFyfGVufDB8fDB8fHww", 
      "https://media.istockphoto.com/id/1148462327/photo/india-anaman-island-beach.webp?a=1&b=1&s=612x612&w=0&k=20&c=e9SD2JzFieKD3zrdFEOgxINE1sQF_sp2O7BSEEw01cw=", 
    ],
  },
  Goa: {
    image1: 
    "https://images.pexels.com/photos/4430322/pexels-photo-4430322.jpeg?w=1500",
    // "https://plus.unsplash.com/premium_photo-1697729701846-e34563b06d47?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8R29hfGVufDB8fDB8fHww",
    image2: [
      "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8R29hfGVufDB8fDB8fHww", 
      "https://images.unsplash.com/photo-1614082242765-7c98ca0f3df3?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8R29hfGVufDB8fDB8fHww", 
      "https://plus.unsplash.com/premium_photo-1697730390320-8412ee5eae82?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTd8fEdvYXxlbnwwfHwwfHx8MA%3D%3D", 
    ],
  },
  Kerala: {
    image1: 
    "https://images.pexels.com/photos/450441/pexels-photo-450441.jpeg?w=1500",
    // "https://plus.unsplash.com/premium_photo-1697729438401-fcb4ff66d9a8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8a2VyYWxhfGVufDB8fDB8fHww",
    image2: [
      "https://plus.unsplash.com/premium_photo-1697729438401-fcb4ff66d9a8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8a2VyYWxhfGVufDB8fDB8fHww", 
      "https://plus.unsplash.com/premium_photo-1697729432049-caca66a1dab6?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGtlcmFsYXxlbnwwfHwwfHx8MA%3D%3D", 
      "https://images.unsplash.com/photo-1610817201767-793a9130ce07?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fGtlcmFsYXxlbnwwfHwwfHx8MA%3D%3D"
    ],
  },
};

const PackagesProvider = ({ children }) => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getPackages = async () => {
      try {
        const response = await fetchDestinationPackages();

        // Track image2 usage count per destination
        const usageCounter = {};

        const updatedPackages = response.data.map((pkg) => {
          const dest = pkg.country;
          const fallback = fallbackImages[dest];

          // Special case: if country is India, look for destination-specific fallback
          if (dest === "India" && pkg.destination) {
            const destinationFallback =fallbackImages[pkg.destination];
            console.log('destinationFallback', destinationFallback)

            if (destinationFallback) {
              // Replace image1 if null or invalid
              if (pkg.image1 && destinationFallback?.image1) {
                pkg.image1 = destinationFallback.image1;
              }

              // Replace image2 if null or invalid
              if (
                (!pkg.image2 || typeof pkg.image2 !== "string") &&
                destinationFallback?.image2?.length > 0
              ) {
                usageCounter[pkg.destination] =
                  (usageCounter[pkg.destination] || 0) + 1;
                const index =
                  (usageCounter[pkg.destination] - 1) %
                  destinationFallback.image2.length;
                pkg.image2 = destinationFallback.image2[index];
              }

              return pkg; // Skip general logic below
            }
          }

          // General fallback logic
          if (pkg.image1 && fallback?.image1) {
            pkg.image1 = fallback.image1;
          }

          if (
            (!pkg.image2 || typeof pkg.image2 !== "string") &&
            fallback?.image2?.length > 0
          ) {
            usageCounter[dest] = (usageCounter[dest] || 0) + 1;
            const index = (usageCounter[dest] - 1) % fallback.image2.length;
            pkg.image2 = fallback.image2[index];
          }

          return pkg;
        });

        // console.log("updatedPackages", updatedPackages);
        setPackages(updatedPackages);
      } catch (error) {
        console.error("Failed to fetch packages:", error);
      } finally {
        setLoading(false);
      }
    };

    getPackages();
  }, []);

  return (
    <PackagesContext.Provider value={{ packages, loading }}>
      {children}
    </PackagesContext.Provider>
  );
};

export default PackagesProvider;
